import { hashValue } from '@utils/hash-value'
import { EVENT } from '@utils/tracking/constants'
import { useCallback } from 'react'

import { useTrackingWrapper } from './use-tracking-wrapper'

export const useTrackSubscription = () => {
  const wrapper = useTrackingWrapper()

  return useCallback(
    async (id: string, email: string) => {
      let user_email = ''
      try {
        user_email = await hashValue(String(email).trim().toLowerCase())
      } catch (e) {
        user_email = ''
      }

      const params = {
        env_template: 'landing-page',
        nom_produit: 'banque',
        page_nom: `entree-crm-banque`,
        client: 0,
        user_email,
        url: '/compte-bancaire/souscrire/entree-crm-banque',
        id_souscription: id,
      }

      if (wrapper) {
        wrapper.triggerEvent(EVENT.CONVERT, null, params)
      }
    },
    [wrapper]
  )
}
